window._ = require('lodash');
import Splide from "@splidejs/splide";
window.Splide = Splide;
import QrScanner from 'qr-scanner';
window.QrScanner = QrScanner

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// try {
//     window.Popper = require('popper.js').default;
//     window.$ = window.jQuery = require('jquery');

//     require('bootstrap');
// } catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.addAxiosHeaders = function (key, value) {
    window.axios.defaults.headers.common[key] = value
}
window.getAxiosHeaders = function () {
    return window.axios.defaults.headers.common
}
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */


// window.Pusher = require('pusher-js');
// let wsHost = window.location.hostname;
// if (process.env.MIX_PUSHER_APP_HOST != "null" && !isEmpty(process.env.MIX_PUSHER_APP_HOST)) {
//     wsHost = process.env.MIX_PUSHER_APP_HOST
// }

// const echoConfig = {
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: (process.env.MIX_PUSHER_APP_SSL === "true" ? true : false),
//     wsHost: wsHost,
//     wsPort: parseInt(process.env.MIX_PUSHER_APP_PORT, 10),
//     disableStats: true,
//     scheme: process.env.MIX_PUSHER_APP_SCHEME,
//     // authEndpoint: process.env.MIX_PUSHER_APP_AUTH_ENDPOINT,
//     // auth: {
//     //     headers: {
//     //         Authorization: "Bearer " + process.env.MIX_PUSHER_APP_TEST_TOKEN,
//     //         Accept: "application/json",
//     //     },
//     // },
// }
// console.log('echoConfig', echoConfig);
// window.initEcho = function () {
//     window.Echo = new Echo(echoConfig);
// }


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */


window.detectBranchChange = function () {
    window.addEventListener('storage', (e) => {
        if (e.key == "chosen_branch_id") {
            if (typeof mySwal == "undefined") {
                setTimeout(() => {
                    window.location.reload()
                }, 300);
                return;
            }
            mySwal.fire({
                title: "ข้อมูลสาขามีการเปลี่ยนแปลง",
                text: `รายการขายที่เกิดขึ้นต่อจากนี้จะเป็นของสาขาล่าสุด`,
                allowOutsideClick: false
            }).then(result => {
                if (result.isConfirmed) {
                    window.onbeforeunload = true;
                    window.location.reload()
                }
            })
        }
    });
}

window.detectBranchChange()
// import './echo';
